import { MenuItem, Select, Typography } from '@mui/material';
import { PLAN_TYPE } from 'helper/checkPlan.helper';
import { useState } from 'react';

const PricingCardShareHolder = ({
    shareHolderTitle,
    shareHolderDescription,
    textAfterSelect,
    defaultSelectValue,
    selectLists,
    handleChange,
    isUpdate,
    isCurrentSelectedPlan
}) => {
    const [value, setValue] = useState(defaultSelectValue);
    const setSelectedId = (e) => {
        if (isUpdate && isCurrentSelectedPlan === PLAN_TYPE.Premium) {
            setValue(defaultSelectValue);
            return;
        }
        const { value } = e.target;
        setValue(value);
        handleChange(value);
    };
    return (
        <div className="pricing-card-wrapper-shareholder-faq pricing-card-shareholder">
            <Typography variant="p" component="p" className="title-text">
                {shareHolderTitle}
            </Typography>

            <Typography variant="p" component="p" className="title-description">
                {shareHolderDescription}
            </Typography>
            <Select
                variant="filled"
                sx={{
                    '& .MuiPaper-root': {
                        minWidth: '200px !important' // Adjust to your desired width
                    }
                }}
                // readOnly={isUpdate && isCurrentSelectedPlan === PLAN_TYPE.Premium}
                className="select-list"
                value={value}
                onChange={(e) => setSelectedId(e)}
                displayEmpty
            >
                {selectLists?.map((list) => {
                    return (
                        <MenuItem key={list.id} className="" value={list.value}>
                            {list.name}
                            {isUpdate &&
                                isCurrentSelectedPlan === PLAN_TYPE.Premium &&
                                String(defaultSelectValue) === String(list.value) &&
                                ` (current)`}
                        </MenuItem>
                    );
                })}
            </Select>
            <Typography variant="p" component="p" className="title-description text-after-button">
                {textAfterSelect}
            </Typography>
        </div>
    );
};
export default PricingCardShareHolder;
